import React, { useEffect, useState } from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { obtenerPedidos, actualizarEstadoPedido, eliminarPedido, agruparPedidos, registrarResultadoPedido, confirmarPedido, cambiarEtapaPedido, guardarInstruccionPago, extenderApartado, liberarApartado } from '../services/pedidosService';
import { ETAPAS, pasosPara, etapaDe, siguienteEtapa, mensajeEtapa } from '../utils/pedidoEtapas';
import ConfirmarPedidoModal from './ConfirmarPedidoModal';
import { obtenerClientes, crearCliente } from '../services/clientesService';
import { RESULTADOS, SIN_RESULTADO, infoResultado, etiquetaMotivo, mensajeSeguimiento } from '../utils/pedidosResultado';
import ResultadoPedidoModal from './ResultadoPedidoModal';
import PedidosEstadisticas from './PedidosEstadisticas';
import AvisosPedidosCard from './AvisosPedidosCard';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';
import { useAuth } from '../context/AuthContext';
import { etiquetaOrigen } from '../utils/origenCatalogo';
import { linkWhatsAppA, linkProductoOG, linkCatalogo, linkPedido } from '../utils/compartir';
import { optimizarFoto } from '../utils/imagen';
import { getNegocioId } from '../services/negocioActual';
import { textoPago } from '../utils/tiendaPago';

const fmt = (n) => `${simboloMoneda()} ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fechaHora = (iso) => new Date(iso).toLocaleString('es-HN', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

// Mensaje para la clienta: con el enlace del producto, WhatsApp muestra la
// vista previa con la FOTO de la prenda (la arma /p). Así no hay que buscarla.
// Un pedido del carrito (varias prendas) lista cada una con su enlace.
export function mensajePedido(p, negocioId) {
  const dinero = (n) => `${simboloMoneda()} ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const enlaceDe = (x) => (x.producto_id ? linkProductoOG({ negocioId, productoId: x.producto_id }) : '');
  const prendas = p.prendas || [p];
  // Pedidos del carrito (traen forma de entrega) o con varias prendas: en lista,
  // con el envío y el total.
  if (prendas.length > 1 || p.entrega) {
    const subtotal = prendas.reduce((s, x) => s + (x.precio || 0) * x.cantidad, 0);
    const envio = p.envio === null || p.envio === undefined ? null : Number(p.envio);
    // Pedido del carrito: UN enlace al pedido (su vista previa trae las fotos de
    // todas las prendas, sql/120). Sin grupo (pedidos viejos): un enlace por prenda.
    const filas = prendas.map((x) => `▪ ${x.cantidad} × ${x.nombre_producto} (${dinero((x.precio || 0) * x.cantidad)}${x.combo ? ` · 🎁 ${x.combo}` : ''})${!p.grupo && enlaceDe(x) ? `\n   ${enlaceDe(x)}` : ''}`);
    if (p.grupo) filas.push(`\n📸 Tu pedido con fotos:\n${linkPedido(p.grupo)}`);
    let cierre;
    if (p.entrega === 'tienda') cierre = `Total: ${dinero(subtotal)}. Lo recoges en la tienda. ¿Cuándo pasas por él? 🛍️`;
    else if (envio !== null) cierre = `Subtotal: ${dinero(subtotal)}\nEnvío: ${envio > 0 ? dinero(envio) : 'gratis 🎉'}\nTotal: ${dinero(subtotal + envio)}\n\n¿Coordinamos tu entrega? 🛍️`;
    else if (p.entrega === 'domicilio') cierre = p.direccion
      ? `Subtotal: ${dinero(subtotal)} + envío a ${p.direccion}. Te confirmo el costo del envío. 🛍️`
      : `Subtotal: ${dinero(subtotal)} + envío. ¿Me compartes tu dirección para decirte el costo del envío? 🛍️`;
    else cierre = `Total: ${dinero(subtotal)}. ¿Coordinamos tu compra? 🛍️`;
    return `¡Hola ${p.cliente_nombre}! 😊 Vi tu pedido:\n\n${filas.join('\n')}\n\n${cierre}`;
  }
  const enlace = enlaceDe(p) ? `\n${enlaceDe(p)}` : '';
  return `¡Hola ${p.cliente_nombre}! 😊 Vi tu pedido de ${p.cantidad} × ${p.nombre_producto} (${dinero((p.precio || 0) * p.cantidad)}). ¿Coordinamos tu compra? 🛍️${enlace}`;
}

// Pedidos que llegan del catálogo. Pendientes → al atenderlos se anota cómo
// terminaron (compró / seguimiento / no compró) y pasan al Historial.
// Estadísticas: cuántos compran, de dónde llegan y por qué no compran.
export default function PedidosView({ onVolver, onCambio, onRegistrarVenta }) {
  const { mostrarToast } = useToast();
  const { negocio } = useAuth();
  // Eliminar pedidos: solo la dueña, aunque el empleado tenga "Borrar registros" (sql/122 lo bloquea en la BD).
  const esVendedora = negocio?.rol === 'vendedora';
  const [estado, setEstado] = useState('pendiente'); // 'pendiente' | 'historial' | 'estadisticas'
  const [pedidos, setPedidos] = useState(null);
  const [error, setError] = useState(null);
  const [ocupado, setOcupado] = useState(null);
  const [resultadoDe, setResultadoDe] = useState(null); // pedido al que se le anota el resultado
  const [confirmarDe, setConfirmarDe] = useState(null); // pedido que se está confirmando
  const [filtroResultado, setFiltroResultado] = useState('todos');
  const [filtroOrigen, setFiltroOrigen] = useState('todos');
  const [filtroEtapa, setFiltroEtapa] = useState('todas');
  const [cambioEtapa, setCambioEtapa] = useState(null); // { p, etapa } que la dueña eligió a mano
  const [busqueda, setBusqueda] = useState('');
  const [version, setVersion] = useState(0); // refresca las estadísticas

  const cargar = () => {
    if (estado === 'estadisticas') return;
    setPedidos(null); setError(null);
    obtenerPedidos({ estado }).then((filas) => setPedidos(agruparPedidos(filas))).catch((e) => setError(mensajeAmigable(e)));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(cargar, [estado]);

  // Si cae un pedido mientras estás aquí (aviso push), la lista se actualiza sola.
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return undefined;
    const alMensaje = (ev) => {
      if (ev.data?.tipo !== 'nuevo-pedido') return;
      if (estado === 'estadisticas') setVersion((v) => v + 1);
      else obtenerPedidos({ estado }).then((filas) => setPedidos(agruparPedidos(filas))).catch(() => {});
    };
    navigator.serviceWorker.addEventListener('message', alMensaje);
    return () => navigator.serviceWorker.removeEventListener('message', alMensaje);
  }, [estado]);

  const cambiarPestana = (clave) => { setEstado(clave); setFiltroResultado('todos'); setFiltroOrigen('todos'); setBusqueda(''); };

  const guardarResultado = async ({ resultado, motivo, nota }) => {
    const p = resultadoDe;
    setOcupado(p.id);
    try {
      await registrarResultadoPedido(p.ids || p.id, {
        resultado, motivo, nota,
        atendidoEn: p.estado === 'pendiente' ? new Date().toISOString() : null,
      });
      const r = infoResultado(resultado);
      mostrarToast(p.estado === 'pendiente' ? `${r.icono} Pedido atendido: ${r.etiqueta}. Lo ves en Historial` : `Resultado actualizado: ${r.etiqueta}`, 'exito');
      setResultadoDe(null);
      setVersion((v) => v + 1);
      onCambio && onCambio();
      cargar();
    } catch (e) {
      mostrarToast(e.code === 'FALTA_SQL_118' ? e.message : mensajeAmigable(e), 'error', 6000);
      if (e.code === 'FALTA_SQL_118') { setResultadoDe(null); onCambio && onCambio(); cargar(); }
    } finally { setOcupado(null); }
  };

  const volverAPendientes = async (p) => {
    setOcupado(p.id);
    try {
      await actualizarEstadoPedido(p.ids || p.id, 'pendiente');
      mostrarToast('El pedido volvió a Pendientes', 'exito');
      setVersion((v) => v + 1);
      onCambio && onCambio();
      cargar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(null); }
  };

  const borrar = async (p) => {
    if (!window.confirm(`¿Eliminar el pedido de ${p.cliente_nombre}? No se puede deshacer.`)) return;
    setOcupado(p.id);
    try {
      await eliminarPedido(p.ids || p.id);
      mostrarToast('Pedido eliminado', 'exito');
      setVersion((v) => v + 1);
      onCambio && onCambio();
      cargar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(null); }
  };

  const contactar = (p) => {
    // En el Historial, a quien no compró o sigue pendiente se le manda un mensaje de seguimiento
    // con el catálogo etiquetado "seguimiento" (así se ve si el seguimiento trae ventas).
    const seguimiento = estado === 'historial' && p.resultado !== 'compro';
    const texto = seguimiento
      ? mensajeSeguimiento(p, {
        negocioNombre: negocio?.nombre,
        enlaceCatalogo: linkCatalogo({ negocioId: getNegocioId(), slug: negocio?.slug, origen: 'seguimiento' }),
      })
      : mensajePedido(p, getNegocioId());
    window.open(linkWhatsAppA(p.cliente_telefono, texto), '_blank', 'noopener,noreferrer');
  };

  // ✅ Confirmar pedido: guarda envío/forma de pago, queda "Confirmado" para la
  // clienta y se abre WhatsApp con el total, cómo pagar y el enlace para seguirlo.
  const hacerConfirmar = async ({ envio, pago, instrucciones, recordar, mensaje }) => {
    const p = confirmarDe;
    // WhatsApp se abre YA (dentro del toque) para que el celular no lo bloquee.
    window.open(linkWhatsAppA(p.cliente_telefono, mensaje), '_blank', 'noopener,noreferrer');
    setOcupado(p.id);
    try {
      await confirmarPedido(p.ids || p.id, { envio, pago });
      if (recordar && pago && instrucciones?.trim()) await guardarInstruccionPago(pago, instrucciones).catch(() => {});
      mostrarToast(`✅ Pedido de ${p.cliente_nombre} confirmado. En su enlace ya ve "Confirmado"`, 'exito', 5000);
      setConfirmarDe(null);
      cargar();
    } catch (e) {
      mostrarToast(`No se pudo guardar la confirmación: ${mensajeAmigable(e)}`, 'error', 6000);
    } finally { setOcupado(null); }
  };

  // Etapa que ve la clienta, elegida a mano (cualquier paso, adelante o atrás).
  // `avisar`: además abre WhatsApp con el aviso de esa etapa.
  const aplicarEtapa = async (p, etapa, avisar) => {
    if (avisar && p.cliente_telefono) {
      window.open(linkWhatsAppA(p.cliente_telefono, mensajeEtapa(p, etapa, p.grupo ? linkPedido(p.grupo) : '')), '_blank', 'noopener,noreferrer');
    }
    setCambioEtapa(null);
    setOcupado(p.id);
    try {
      await cambiarEtapaPedido(p.ids || p.id, etapa);
      mostrarToast(`${ETAPAS[etapa].icono} ${p.cliente_nombre}: ${ETAPAS[etapa].etiqueta}`, 'exito');
      cargar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(null); }
  };

  // Piezas apartadas (sql/123): +24 h o liberarlas para que vuelvan al catálogo.
  const cambiarApartado = async (p, accion) => {
    if (accion === 'liberar' && !window.confirm(`¿Liberar las piezas del pedido de ${p.cliente_nombre}? Vuelven a estar disponibles en el catálogo.`)) return;
    setOcupado(p.id);
    try {
      if (accion === 'liberar') { await liberarApartado(p.ids || p.id); mostrarToast('🔓 Piezas liberadas: ya se ven disponibles en el catálogo', 'exito'); }
      else { await extenderApartado(p.ids || p.id, 24); mostrarToast('⏳ Apartado por 24 horas más', 'exito'); }
      cargar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(null); }
  };

  // Guarda a la persona en Clientes (si no está) para darle seguimiento desde el CRM.
  const guardarEnClientes = async (p) => {
    setOcupado(p.id);
    try {
      const digitos = (t) => (t || '').replace(/\D/g, '').slice(-8);
      const tel = digitos(p.cliente_telefono);
      const existentes = await obtenerClientes();
      const ya = existentes.find((c) => (tel && digitos(c.telefono) === tel)
        || (!tel && (c.nombre || '').trim().toLowerCase() === (p.cliente_nombre || '').trim().toLowerCase()));
      if (ya) { mostrarToast(`${ya.nombre} ya está en Clientes 👍`, 'info'); return; }
      const prendas = (p.prendas || [p]).map((x) => x.nombre_producto).join(', ');
      const r = infoResultado(p.resultado);
      const nota = `Pedido del catálogo ${new Date(p.creado_en).toLocaleDateString('es-HN')}: ${prendas}. Resultado: ${r.etiqueta}`
        + `${p.motivo ? ` (${etiquetaMotivo(p.motivo)})` : ''}. Llegó por: ${etiquetaOrigen(p.origen).etiqueta}.`;
      await crearCliente({ nombre: p.cliente_nombre || 'Cliente del catálogo', telefono: p.cliente_telefono, notas: nota });
      mostrarToast(`➕ ${p.cliente_nombre} guardada en Clientes`, 'exito');
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); } finally { setOcupado(null); }
  };

  // Filtros del Historial.
  const texto = busqueda.trim().toLowerCase();
  const lista = (pedidos || []).filter((p) => estado !== 'historial' || (
    (filtroResultado === 'todos' || (filtroResultado === 'sin' ? !p.resultado : p.resultado === filtroResultado))
    && (filtroOrigen === 'todos' || (p.origen || '') === filtroOrigen)
    && (filtroEtapa === 'todas' || etapaDe(p) === filtroEtapa)
    && (!texto || [p.cliente_nombre, p.cliente_telefono, ...(p.prendas || [p]).map((x) => `${x.nombre_producto} ${x.codigo_producto}`)]
      .some((v) => (v || '').toLowerCase().includes(texto)))
  ));
  const cuentaResultado = (clave) => (pedidos || []).filter((p) => (clave === 'sin' ? !p.resultado : p.resultado === clave)).length;
  const origenesHistorial = [...new Set((pedidos || []).map((p) => p.origen || ''))];
  const cuentaEtapa = (k) => (pedidos || []).filter((p) => etapaDe(p) === k).length;

  const pill = (activo) => ({
    padding: '7px 14px', borderRadius: '999px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
    border: `1px solid ${activo ? 'var(--color-primario,#DB2777)' : '#E5E7EB'}`,
    backgroundColor: activo ? 'var(--color-primario,#DB2777)' : 'white', color: activo ? 'white' : '#6B7280',
  });
  const btn = { padding: '8px 14px', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' };

  return (
    <div className="k-page" style={{ maxWidth: '900px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 className="k-page-title">🛒 Pedidos del catálogo</h2>
        <button onClick={onVolver} className="k-btn-soft">← Volver</button>
      </div>

      <AvisosPedidosCard />

      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
        {[['pendiente', 'Pendientes'], ['historial', '📋 Historial'], ['estadisticas', '📊 Estadísticas']].map(([clave, txt]) => (
          <button key={clave} onClick={() => cambiarPestana(clave)} style={pill(estado === clave)}>{txt}</button>
        ))}
      </div>

      {estado === 'estadisticas' && <PedidosEstadisticas refrescar={version} />}

      {estado !== 'estadisticas' && <>
      {estado === 'historial' && pedidos && pedidos.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '8px' }}>
            <button onClick={() => setFiltroResultado('todos')} style={pill(filtroResultado === 'todos')}>Todos ({pedidos.length})</button>
            {[...RESULTADOS, { ...SIN_RESULTADO, clave: 'sin' }].map((r) => {
              const n = cuentaResultado(r.clave);
              if (!n && r.clave === 'sin') return null;
              return <button key={r.clave} onClick={() => setFiltroResultado(r.clave)} style={pill(filtroResultado === r.clave)}>{r.icono} {r.etiqueta} ({n})</button>;
            })}
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <input type="search" className="k-input" placeholder="🔍 Buscar por nombre, teléfono o producto" value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)} style={{ flex: '1 1 240px', marginBottom: 0 }} />
            <select value={filtroOrigen} onChange={(e) => setFiltroOrigen(e.target.value)} aria-label="Filtrar por origen"
              style={{ padding: '10px', borderRadius: '10px', border: '1px solid #D1D5DB', fontSize: '13px', backgroundColor: 'white' }}>
              <option value="todos">Todos los orígenes</option>
              {origenesHistorial.map((o) => <option key={o} value={o}>{etiquetaOrigen(o || null).icono} {etiquetaOrigen(o || null).etiqueta}</option>)}
            </select>
            <select value={filtroEtapa} onChange={(e) => setFiltroEtapa(e.target.value)} aria-label="Filtrar por etapa"
              style={{ padding: '10px', borderRadius: '10px', border: `1px solid ${filtroEtapa !== 'todas' ? 'var(--color-primario,#DB2777)' : '#D1D5DB'}`, fontSize: '13px', backgroundColor: 'white' }}>
              <option value="todas">Todas las etapas</option>
              {Object.keys(ETAPAS).filter((k) => cuentaEtapa(k) > 0).map((k) => (
                <option key={k} value={k}>{ETAPAS[k].icono} {k === 'pagado' ? 'Pagado (por enviar)' : ETAPAS[k].etiqueta} ({cuentaEtapa(k)})</option>
              ))}
            </select>
          </div>
        </div>
      )}

      {!pedidos && !error && <div style={{ textAlign: 'center', padding: '40px', color: '#6B7280' }}>⏳ Cargando pedidos...</div>}
      {error && <div style={{ padding: '16px', backgroundColor: '#FEE2E2', borderRadius: '12px', border: '1px solid #FCA5A5', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</div>}

      {pedidos && lista.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#9CA3AF' }}>
          {estado === 'pendiente' ? 'No hay pedidos pendientes por ahora. 📭' : pedidos.length ? 'Ningún pedido con esos filtros.' : 'Aún no hay pedidos atendidos.'}
        </div>
      )}

      {pedidos && lista.map((p) => {
        const r = infoResultado(p.resultado);
        return (
        <div key={p.id} className="k-card" style={{ padding: '16px', marginBottom: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', minWidth: 0 }}>
            {p.prendas.length === 1 && p.foto && <img src={optimizarFoto(p.foto, 160)} alt={p.nombre_producto} loading="lazy" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '10px', flex: '0 0 auto', border: '1px solid #F1EEF8' }} />}
            <div style={{ minWidth: 0 }}>
              {p.prendas.length === 1 ? (
                <p style={{ margin: 0, fontWeight: 'bold', color: '#111827', fontSize: '15px' }}>{p.cantidad} × {p.nombre_producto} <span style={{ color: '#9CA3AF', fontWeight: 400, fontSize: '13px' }}>({p.codigo_producto})</span></p>
              ) : (
                <>
                  <p style={{ margin: '0 0 6px', fontWeight: 'bold', color: '#111827', fontSize: '15px' }}>👜 Pedido de {p.prendas.reduce((n, x) => n + x.cantidad, 0)} piezas</p>
                  {p.prendas.map((x) => (
                    <div key={x.id} style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '6px' }}>
                      {x.foto ? <img src={optimizarFoto(x.foto, 120)} alt="" loading="lazy" style={{ width: '44px', height: '44px', objectFit: 'cover', borderRadius: '8px', flex: '0 0 auto', border: '1px solid #F1EEF8' }} />
                        : <span style={{ width: '44px', textAlign: 'center', fontSize: '22px' }}>🛍️</span>}
                      <span style={{ fontSize: '13px', color: '#111827' }}>{x.cantidad} × {x.nombre_producto} <span style={{ color: '#9CA3AF' }}>({x.codigo_producto}) · {fmt((x.precio || 0) * x.cantidad)}</span>{x.combo && <span style={{ color: '#C2410C', fontWeight: 700 }}> · 🎁 {x.combo}</span>}</span>
                    </div>
                  ))}
                </>
              )}
              <p style={{ margin: '3px 0 0', fontSize: '13px', color: '#374151' }}>👤 {p.cliente_nombre} · 📱 {p.cliente_telefono || 'sin teléfono'}</p>
              {p.entrega && (
                <p style={{ margin: '3px 0 0', fontSize: '13px', color: '#374151' }}>
                  {p.entrega === 'tienda' ? '🏬 Recoge en la tienda'
                    : p.envio === null || p.envio === undefined ? '🚚 Envío a domicilio · costo por coordinar'
                      : `🚚 Envío a domicilio · ${Number(p.envio) > 0 ? fmt(p.envio) : 'gratis'}`}
                </p>
              )}
              {p.direccion && <p style={{ margin: '3px 0 0', fontSize: '13px', color: '#374151' }}>📍 {p.direccion}</p>}
              {p.pago && <p style={{ margin: '3px 0 0', fontSize: '13px', color: '#374151' }}>Pago: {textoPago(p.pago)}</p>}
              {p.nota && <p style={{ margin: '3px 0 0', fontSize: '13px', color: '#6B7280' }}>📝 {p.nota}</p>}
              <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
                {fechaHora(p.creado_en)} · <span title="De dónde llegó al catálogo">{etiquetaOrigen(p.origen).icono} {etiquetaOrigen(p.origen).etiqueta}</span>
              </p>
              {/* Etapas que ve la clienta en su enlace (sql/121) */}
              {p.etapa && (etapaDe(p) === 'cancelado' ? (
                <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#9CA3AF' }}>✖️ Cancelado para la clienta</p>
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px', alignItems: 'center' }} aria-label="Etapa del pedido (toca una para cambiarla)">
                  {pasosPara(p.entrega).map((k, i, pasos) => {
                    const hecho = pasos.indexOf(etapaDe(p)) >= i;
                    const actual = etapaDe(p) === k;
                    return (
                      <button key={k} type="button" disabled={actual || ocupado === p.id}
                        onClick={() => setCambioEtapa({ p, etapa: k })}
                        title={actual ? 'Etapa actual' : `Cambiar a ${ETAPAS[k].etiqueta}`}
                        style={{ fontSize: '11px', padding: '3px 9px', borderRadius: '999px', fontWeight: actual ? 700 : 500, fontFamily: 'inherit',
                          cursor: actual ? 'default' : 'pointer', border: 'none',
                          backgroundColor: actual ? 'var(--color-primario,#DB2777)' : hecho ? '#FCE7F3' : '#F3F4F6',
                          color: actual ? 'white' : hecho ? '#9D174D' : '#9CA3AF' }}>
                        {hecho ? ETAPAS[k].icono : '○'} {ETAPAS[k].etiqueta}
                      </button>
                    );
                  })}
                </div>
              ))}
              {estado === 'pendiente' && p.producto_id && etapaDe(p) !== 'cancelado' && (() => {
                const fijo = ['pagado', 'enviado', 'listo'].includes(etapaDe(p));
                const vigente = fijo || (p.apartado_hasta && new Date(p.apartado_hasta) > new Date());
                return (
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', marginTop: '6px', fontSize: '12px' }}>
                    <span style={{ padding: '3px 9px', borderRadius: '999px', fontWeight: 600,
                      backgroundColor: vigente ? '#FEF3C7' : '#F3F4F6', color: vigente ? '#92400E' : '#6B7280' }}>
                      {fijo ? '⏳ Piezas apartadas (ya pagó)'
                        : vigente ? `⏳ Apartadas hasta ${fechaHora(p.apartado_hasta)}`
                          : p.apartado_hasta ? `⌛ El apartado venció ${fechaHora(p.apartado_hasta)}` : '🔓 Sin apartar'}
                    </span>
                    {!fijo && (
                      <button type="button" onClick={() => cambiarApartado(p, 'extender')} disabled={ocupado === p.id}
                        style={{ fontSize: '12px', padding: '3px 9px', borderRadius: '999px', border: '1px solid #FCD34D', background: 'white', color: '#92400E', cursor: 'pointer', fontFamily: 'inherit' }}>
                        {vigente ? '+24 h' : '⏳ Apartar 24 h'}
                      </button>
                    )}
                    {vigente && !fijo && (
                      <button type="button" onClick={() => cambiarApartado(p, 'liberar')} disabled={ocupado === p.id}
                        style={{ fontSize: '12px', padding: '3px 9px', borderRadius: '999px', border: '1px solid #E5E7EB', background: 'white', color: '#6B7280', cursor: 'pointer', fontFamily: 'inherit' }}>
                        🔓 Liberar
                      </button>
                    )}
                  </div>
                );
              })()}
              {estado === 'historial' && (
                <div style={{ marginTop: '8px' }}>
                  <span style={{ display: 'inline-block', fontSize: '12px', fontWeight: 700, padding: '3px 10px', borderRadius: '999px', backgroundColor: r.fondo, color: r.color }}>
                    {r.icono} {r.etiqueta}{p.motivo ? ` · ${etiquetaMotivo(p.motivo)}` : ''}
                  </span>
                  {p.atendido_en && <span style={{ fontSize: '12px', color: '#9CA3AF', marginLeft: '8px' }}>Atendido {fechaHora(p.atendido_en)}</span>}
                  {p.nota_resultado && <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6B7280' }}>💭 {p.nota_resultado}</p>}
                </div>
              )}
            </div>
            </div>
            <p style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: 'var(--color-primario,#DB2777)', whiteSpace: 'nowrap', textAlign: 'right' }}>{fmt(p.total + (Number(p.envio) || 0))}{p.envio > 0 && <span style={{ display: 'block', fontSize: '11px', fontWeight: 400, color: '#9CA3AF' }}>incluye envío</span>}</p>
          </div>

          <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
            <button onClick={() => contactar(p)} disabled={!p.cliente_telefono}
              style={{ ...btn, backgroundColor: '#25D366', color: 'white', border: 'none', opacity: p.cliente_telefono ? 1 : 0.5 }}>
              💬 {estado === 'historial' && p.resultado !== 'compro' ? 'Dar seguimiento' : 'Contactar'}
            </button>
            {onRegistrarVenta && p.resultado !== 'compro' && (
              <button onClick={() => onRegistrarVenta(p)} disabled={ocupado === p.id}
                title="Abre Vender con las prendas, la clienta y el origen ya puestos. Al cobrar, el pedido queda como Compró."
                style={{ ...btn, backgroundColor: 'var(--color-primario,#DB2777)', color: 'white', border: 'none' }}>
                🛒 Registrar venta
              </button>
            )}
            {estado === 'pendiente' && p.etapa && ['recibido', 'confirmado'].includes(etapaDe(p)) && (
              <button onClick={() => setConfirmarDe(p)} disabled={ocupado === p.id || !p.cliente_telefono}
                title="Le mandas el total y cómo pagar; en su enlace verá Confirmado"
                style={{ ...btn, backgroundColor: etapaDe(p) === 'recibido' ? '#0EA5E9' : 'white', color: etapaDe(p) === 'recibido' ? 'white' : '#0369A1', border: etapaDe(p) === 'recibido' ? 'none' : '1px solid #7DD3FC' }}>
                {etapaDe(p) === 'recibido' ? '📲 Confirmar pedido' : '🔁 Reenviar confirmación'}
              </button>
            )}
            {estado === 'historial' && p.resultado === 'compro' && siguienteEtapa(p) && (
              <button onClick={() => setCambioEtapa({ p, etapa: siguienteEtapa(p) })} disabled={ocupado === p.id}
                title="Cambia la etapa que ve la clienta (y si quieres le avisas por WhatsApp)"
                style={{ ...btn, backgroundColor: '#0EA5E9', color: 'white', border: 'none' }}>
                {ETAPAS[siguienteEtapa(p)].icono} Marcar {ETAPAS[siguienteEtapa(p)].etiqueta.toLowerCase()}
              </button>
            )}
            {p.grupo && p.etapa && (
              <a href={linkPedido(p.grupo)} target="_blank" rel="noopener noreferrer" title="Lo que ve la clienta en su enlace"
                style={{ ...btn, backgroundColor: 'white', color: '#374151', border: '1px solid #E5E7EB', textDecoration: 'none' }}>
                🔗 Ver su pedido
              </a>
            )}
            {estado === 'pendiente' ? (
              <button onClick={() => setResultadoDe(p)} disabled={ocupado === p.id}
                style={{ ...btn, backgroundColor: 'var(--k-verde)', color: 'white', border: 'none' }}>
                ✅ Marcar atendido
              </button>
            ) : (
              <>
                <button onClick={() => setResultadoDe(p)} disabled={ocupado === p.id}
                  style={{ ...btn, backgroundColor: 'white', color: '#374151', border: '1px solid #E5E7EB' }}>
                  ✏️ {p.resultado ? 'Cambiar resultado' : 'Anotar resultado'}
                </button>
                <button onClick={() => guardarEnClientes(p)} disabled={ocupado === p.id}
                  style={{ ...btn, backgroundColor: 'white', color: '#374151', border: '1px solid #E5E7EB' }}>
                  ➕ Guardar en Clientes
                </button>
                <button onClick={() => volverAPendientes(p)} disabled={ocupado === p.id}
                  style={{ ...btn, backgroundColor: 'white', color: '#6B7280', border: '1px solid #E5E7EB' }}>
                  ↩️ A pendientes
                </button>
              </>
            )}
            {!esVendedora && <button onClick={() => borrar(p)} disabled={ocupado === p.id}
              style={{ ...btn, backgroundColor: 'white', color: '#DC2626', border: '1px solid #FCA5A5' }}>
              🗑️ Eliminar
            </button>}
          </div>
        </div>
        );
      })}

      {estado === 'pendiente' && (
        <p style={{ margin: '14px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
          Si compró, usa 🛒 Registrar venta: abre Vender con todo puesto y al cobrar el pedido queda como "Compró". Si ya registraste la venta en Vender, solo toca ✅ Marcar atendido → Compró (no se duplica).
        </p>
      )}
      </>}

      {cambioEtapa && (
        <div onClick={() => setCambioEtapa(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(20,10,30,.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Cambiar etapa"
            style={{ background: '#fff', borderRadius: '18px', width: '100%', maxWidth: '400px', padding: '20px', boxSizing: 'border-box' }}>
            <b style={{ fontSize: '16px' }}>{ETAPAS[cambioEtapa.etapa].icono} Cambiar a: {ETAPAS[cambioEtapa.etapa].etiqueta}</b>
            <p style={{ margin: '6px 0 16px', fontSize: '13px', color: '#6B7280' }}>
              Pedido de {cambioEtapa.p.cliente_nombre}. En su enlace verá esta etapa.
            </p>
            <div style={{ display: 'grid', gap: '8px' }}>
              {cambioEtapa.p.cliente_telefono && cambioEtapa.etapa !== 'recibido' && (
                <button onClick={() => aplicarEtapa(cambioEtapa.p, cambioEtapa.etapa, true)}
                  style={{ ...btn, backgroundColor: '#25D366', color: 'white', border: 'none', padding: '11px' }}>
                  💬 Cambiar y avisarle por WhatsApp
                </button>
              )}
              <button onClick={() => aplicarEtapa(cambioEtapa.p, cambioEtapa.etapa, false)}
                style={{ ...btn, backgroundColor: 'var(--color-primario,#DB2777)', color: 'white', border: 'none', padding: '11px' }}>
                Solo cambiar (sin avisar)
              </button>
              <button onClick={() => setCambioEtapa(null)} className="k-btn-soft">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {confirmarDe && (
        <ConfirmarPedidoModal pedido={confirmarDe} enlace={confirmarDe.grupo ? linkPedido(confirmarDe.grupo) : ''}
          guardando={ocupado === confirmarDe.id} onConfirmar={hacerConfirmar} onCerrar={() => setConfirmarDe(null)} />
      )}

      {resultadoDe && (
        <ResultadoPedidoModal pedido={resultadoDe} guardando={ocupado === resultadoDe.id}
          onGuardar={guardarResultado} onCerrar={() => setResultadoDe(null)} />
      )}
    </div>
  );
}
